import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    feature: String,
    plan: String,
  };

  connect() {
    this.trackEvent("billing_feature_card_shown");
  }

  click() {
    this.trackEvent("billing_feature_card_clicked");
  }

  dismiss() {
    this.trackEvent("billing_feature_card_dismissed");
  }

  trackEvent(eventName) {
    if (typeof window.posthog !== "undefined") {
      window.posthog.capture(eventName, {
        feature_name: this.featureValue,
        plan: this.planValue,
      });
    }
  }
}
